import styled from '@emotion/styled';
import { H3, Text, SmallText } from 'ds/components/typography';
import { Link } from 'ds/components/link';
import { Link as RouteLink } from 'components/link';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const Main = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.colors.neutrals.grey6}`,
  borderRadius: theme.borderRadius.small,
  padding: theme.spacing(3, 3, 2),
  gap: theme.spacing(3),
}));

export const ReviewsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2, 0),
  flexWrap: 'wrap',
}));

export const Heading = styled(H3.withComponent('h2'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const StyledRouteLink = styled(RouteLink)({
  textDecoration: 'none',
});

export const MoreInfoLink = styled(Link)(({ theme }) => ({
  cursor: 'pointer',
  fontWeight: 500,
}));

export const ReviewRow = styled.div(({ theme }) => ({
  display: 'flex',
  flexBasis: '43%',
  alignItems: 'center',
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    flexBasis: '100%',
  },
}));

export const IconWrap = styled.div(({ theme }) => ({
  flexBasis: theme.spacing(3),
  paddingLeft: theme.spacing(1),
  'svg': {
    display: 'block',
  },
}));

export const ReviewTitle = styled(Text)(({ theme }) => ({
  flexBasis: '112px',
  paddingLeft: theme.spacing(1.5),
  color: theme.colors.neutrals.grey1,
}));

export const MobileReviewTitle = styled(SmallText)(({ theme }) => ({
  flexBasis: '141px',
  paddingLeft: theme.spacing(1.5),
  color: theme.colors.neutrals.grey1,
}));

export const ScoreValue = styled(Text)(({ theme }) => ({
  flexBasis: '40px',
  textAlign: 'left',
  color: theme.colors.neutrals.grey1,
}));

export const ScoreBar = styled.div<{ rating: number }>(({ theme, rating }) => ({
  position: 'relative',
  flexGrow: 1,
  height: '10px',
  background: theme.colors.neutrals.grey8,
  '::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: `${100 - rating}%`,
    background: theme.colors.brand.main,
  },
}));
